import { IAttachment } from '../api/vault';
import { getAssetAttachments } from '../api/vault/assetAttachments';
import { getDownloadLink } from '../api/vault/assetDetails';
import { AssetHit } from '../api/vault/searchEngine';
import { VAULT_VIDEO_TYPE } from '../constants';
import toast from './toast';

export const copyAssetsToClipboard = async (assets: AssetHit[]) => {
  toast(`Generating download link${assets.length > 1 ? 's' : ''} for ${assets.length} asset${assets.length > 1 ? 's' : ''} `, {
    type: toast.TYPE.INFO,
  });
  const daysToExpire = 1; // Default to 1 day
  const assetsWithLinks = await Promise.all(
    assets.map(async (asset) => {
      const { _id } = asset;
      const { title, type, videoType } = asset._source;
      let link: string;
      let attachmentLink: IAttachment;
      try {
        // VV-539: 'share' replaces `excludeLog=true`. Copying a link to the clipboard used
        // to be recorded nowhere at all — the flag suppressed the only log entry, and
        // unlike the email share there was no second row written afterwards. It is now
        // recorded as Shared, which is what it is: a link handed out, not bytes fetched.
        const response = await getDownloadLink({ id: _id }, daysToExpire * 24, 'share');
        link = response.data.data;
        const parsedLink = decodeURIComponent(link).split(/filename=(.*\.)/);
        if (videoType === VAULT_VIDEO_TYPE.Exchange && parsedLink.length === 3) {
          const fileName = `${parsedLink[1]}xchange`;
          const attachmentsResponse = await getAssetAttachments(fileName, _id, daysToExpire * 24);
          if (attachmentsResponse.data.data.length) {
            [attachmentLink] = attachmentsResponse.data.data;
          }
        } else {
          console.warn(`Could not parse filename from download link for asset "${_id}"`);
        }
      } catch (e) {
        console.error(`Could not find download link for asset "${_id}"`);
      }
      return {
        _id,
        title,
        type,
        link,
        videoType,
        attachmentLink: attachmentLink ? attachmentLink.url : null,
      };
    }) // eslint-disable-line
  );

  let clipBoardString = '';
  for (let i = 0; i < assetsWithLinks.length; i += 1) {
    const assetWithLink = assetsWithLinks[i];
    clipBoardString += `${assetWithLink.title}: ${assetWithLink.link}`;
    if (assetWithLink.attachmentLink) clipBoardString += `\nExchange file: ${assetWithLink.attachmentLink}`;
    if (i !== assetsWithLinks.length - 1) clipBoardString += '\n';
  }

  navigator.clipboard.writeText(clipBoardString);
  const toastMessage = `Copied ${assetsWithLinks.length} asset link${assetsWithLinks.length > 1 ? 's' : ''} to clipboard`;
  toast(toastMessage, {
    type: toast.TYPE.SUCCESS,
  });
};
